<!-- not-found.component.html -->
<div class="not-found-container">
  <!-- Partículas de fondo -->
  <div class="particle" *ngFor="let p of particles" [ngStyle]="{
    'left': p.left,
    'top': p.top,
    'width': p.size,
    'height': p.size,
    'animation-delay': p.delay
  }"></div>

  <div class="content">
    <div class="error-code">
      <span>4</span>
      <mat-icon>sentiment_very_dissatisfied</mat-icon>
      <span>4</span>
    </div>
    
    <h1 class="title">¡Ups! Página no encontrada</h1>
    
    <p class="message">
      Lo sentimos, la página que estás buscando no existe o ha sido movida.
    </p>
    
    <button mat-raised-button color="primary" routerLink="/home" class="home-button">
      <mat-icon>home</mat-icon>
      Volver al inicio
    </button>
  </div>
</div>